import { AppModule } from 'app/module';
import './styles.scss';

export class CompanyImageBox extends AppModule {
    domBindings() {
        return {
            thumbnails: ['.m-companyImageBox__image--thumbnail'],
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.thumbnails.length; i += 1) {
            this.dom.thumbnails[i].addEventListener('click', (e) => this.openLightBox(e));
        }
    }

    openLightBox(e) {
        const activeImage = e.currentTarget.getAttribute('data-mobilesrc');
        this.events.emit('openMediaItem', activeImage);
    }
}
